<template>
  <div class="item-container">
    <el-row :gutter="15">
        <el-col :span="5">
            <div class="pt-it-img">
                <el-image class="el-image" :src="data.ptImageUrl">
                    <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                    </div>
                </el-image>
            </div>
        </el-col>
        <el-col :span="19">
            <el-row>
                <div style="float: left; height: 30px;">
                    <span style="font-size: 16px; color: rgb(7, 54, 125); font-weight: bold;">
                        {{ openNo }}
                    </span>
                    <span class="pt-it-title">
                        {{data.ptName}}
                    </span>
                </div>
                <div style="float: left; height: 30px; margin-left: 5px;" v-if="data.lang === 0">
                    <el-tag v-if="data.statusCode === '10'" type="success">{{data.lawStatus}}</el-tag>
                    <el-tag v-else-if="data.statusCode === '21'">{{data.lawStatus}}</el-tag>
                    <el-tag v-else type="danger">{{data.lawStatus}}</el-tag>
                    <el-tag v-if="data.pledgeQuantity !== '0'" type="success">质押</el-tag>
                    <el-tag v-if="data.patentRightTransferQuantity !== '0' || data.applicationRightTransferQuantity !== '0'" type="success">转让</el-tag>
                    <el-tag v-if="data.licenseQuantity !== '0'" type="success">许可</el-tag>
                </div>
            </el-row>
            <el-row>
                <div class="pt-it-cell-title">申请号：{{data.ptNo}}</div>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <div class="pt-it-cell-title">申请日：{{data.applyDate}}</div>
                </el-col>
                <el-col :span="12">
                    <div class="pt-it-cell-title">公开(公告)日：{{data.openDate}}</div>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <div class="pt-it-cell-title">申请人：{{data.ptProposer}}</div>
                </el-col>
                <el-col :span="12">
                    <div class="pt-it-cell-title">发明人：{{data.ptInventor}}</div>
                </el-col>
            </el-row>
            <el-row>
                <div class="pt-it-cell-title">分类号：{{data.ipc}}</div>
            </el-row>
            <el-row v-if="data.techDesc === null || data.techDesc === ''">
                <div class="pt-it-cell-title" style="color: rgb(7, 54, 125);">摘要：</div>
                <div class="pt-it-cell-value">{{data.abs}}</div>
            </el-row>
            <el-row v-else>
                <div class="pt-it-cell-title" style="color: #F56C6C;">技术手段：</div>
                <div class="pt-it-cell-value" style="color: #F56C6C;">{{data.techDesc}}</div>
            </el-row>
        </el-col>
    </el-row>
    <!-- <div class="pt-it-index">1</div> -->
  </div>
</template>

<script>
export default {
    props: ['data'],
    data() {
        return {

        }
    },
    computed: {
        openNo: function() {
            var dbAry = this.data.openNo.split(',');
            return dbAry[1];
        }
    }
}
</script>

<style scoped>
.item-container {
    width: 100%;
    height: 185px;
}
.pt-it-img {
    width: 160px;
    height: 160px;
    margin-top: 10px;
    margin-left: 10px;
}
.el-image {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f5f7fa;
    text-align: center;
    font-size: 30px;
}
.image-slot {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    color: #909399;
    font-size: 30px;
}
.pt-it-title {
    height: 30px;
    font-size: 16px;
    font-weight: bold;
    line-height: 25px;
    margin-left: 10px;
    overflow: hidden;
    color: #303133;
}
.pt-it-cell-title {
    width: 100%;
    height: auto;
    color: #909399;
}
.pt-it-cell-value {
    width: 100%;
    height: 40px;
    line-height: 20px;
    color: rgb(7, 54, 125);
    overflow: hidden;
    padding-right: 10px;
}
.pt-it-index {
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    height: 40px;
    background-color: #606266;
    opacity: 0.6;
    border-radius: 0 0 0 40px;
    text-align: center;
    font-size: 16px;
    color: white;
    line-height: 40px;
    font-weight: bold;
}
</style>